module.exports = __webpack_public_path__ + "img/avatar_random_16.db307369.png";